import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="loader">
        <svg
          role="img"
          aria-label="Mouth and eyes come from 9:00 and rotate clockwise into position, right eye blinks, then all parts rotate and merge into 3:00"
          className="smiley"
          viewBox="0 0 128 128"
          width="128px"
          height="128px"
        >
          <defs>
            <clipPath id="smiley-eyes">
              <circle
                className="smiley__eye1"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(-40,64,64) translate(0,-56)"
              />
              <circle
                className="smiley__eye2"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(40,64,64) translate(0,-56)"
              />
            </clipPath>
            <linearGradient id="smiley-grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#000" />
              <stop offset="100%" stopColor="#fff" />
            </linearGradient>
            <mask id="smiley-mask">
              <rect
                x="0"
                y="0"
                width="128"
                height="128"
                fill="url(#smiley-grad)"
              />
            </mask>
          </defs>
          <g
            strokeLinecap="round"
            strokeWidth="12"
            strokeDasharray="175.93 351.86"
          >
            <g>
              <rect
                fill="hsl(193,90%,50%)"
                width="128"
                height="64"
                clipPath="url(#smiley-eyes)"
              />
              <g fill="none" stroke="hsl(193,90%,50%)">
                <circle
                  className="smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />
                <circle
                  className="smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(0,64,64)"
                />
              </g>
            </g>
            <g mask="url(#smiley-mask)">
              <rect
                fill="hsl(223,90%,50%)"
                width="128"
                height="64"
                clipPath="url(#smiley-eyes)"
              />
              <g fill="none" stroke="hsl(223,90%,50%)">
                <circle
                  className="smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />
                <circle
                  className="smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(0,64,64)"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};

const teamData = {
  "chennai-super-kings": {
    players: [
      {
        name: "Ruturaj Gaikwad",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/102.png",
      },
      {
        name: "MS Dhoni",
        role: "Wicketkeeper Batter",
        playercode: "20572",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/57.png",
      },
      {
        name: "Sanju Samson",
        role: "Wicketkeeper Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/190.png",
      },
      {
        name: "Dewald Brevis",
        role: "Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/797.png",
      },
      {
        name: "Kartik Sharma",
        role: "Wicketkeeper Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4540.png",
      },
      {
        name: "Sarfaraz Khan",
        role: "Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/139.png",
      },
      {
        name: "Urvil Patel",
        role: "Wicketkeeper Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1486.png",
      },
      {
        name: "Jamie Overton",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1216.png",
      },
      {
        name: "Ramakrishna Ghosh",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3559.png",
      },
      {
        name: "Prashant Veer",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4541.png",
      },
      {
        name: "Matthew William Short",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2032.png",
      },
      {
        name: "Aman Khan",
        role: "All-rounder",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/979.png",
      },
      {
        name: "Zak Foulkes",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3493.png",
      },
      {
        name: "Shivam Dube",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/211.png",
      },
      {
        name: "Khaleel Ahmed",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/8.png",
      },
      {
        name: "Noor Ahmad",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/975.png",
      },
      {
        name: "Anshul Kamboj",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3106.png",
      },
      {
        name: "Mukesh Choudhary",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/970.png",
      },
      {
        name: "Shreyas Gopal",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/192.png",
      },
      {
        name: "Gurjapneet Singh",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2256.png",
      },
      {
        name: "Akeal Hosein",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/722.png",
      },
      {
        name: "Matt Henry",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/71.png",
      },
      {
        name: "Rahul Chahar",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/171.png",
      },
      {
        name: "Spencer Johnson",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2518.png",
      },
      {
        name: "Akash Madhwal",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1045.png",
      },
    ],
    bgImage: "https://4kwallpapers.com/images/walls/thumbs_3t/4938.png",
    textColor: "black",
    logo: "https://documents.iplt20.com/ipl/CSK/logos/Logooutline/CSKoutline.png",
    displayName: "Chennai Super Kings",
    trophyYears: "2010, 2011, 2018, 2021, 2023",
    officialSite: "https://www.chennaisuperkings.com/",
    captain: "Ruturaj Gaikwad",
    coach: "Stephen Fleming",
    owner: "Chennai Super Kings Cricket Limited",
    venue: "M.A. Chidambaram Stadium",
  },
  "mumbai-indians": {
    players: [
      {
        name: "Rohit Sharma",
        role: "Batter",
        playercode: "20572",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2025/6.png",
      },
      {
        name: "Surya Kumar Yadav",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2025/174.png",
      },
      {
        name: "Robin Minz",
        role: "Wicketkeeper Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3103.png",
      },
      {
        name: "Sherfane Rutherford",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/122.png",
      },
      {
        name: "Ryan Rickelton",
        role: "Wicketkeeper Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/743.png",
      },
      {
        name: "Quinton de Kock",
        role: "Wicketkeeper Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/170.png",
      },
      {
        name: "Danish Malewar",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4546.png",
      },
      {
        name: "N. Tilak Varma",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/993.png",
      },
      {
        name: "Hardik Pandya",
        role: "All-rounder",
        playercode: "20617",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2025/54.png",
      },
      {
        name: "Naman Dhir",
        role: "All-rounder",
        playercode: "20617",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3107.png",
      },
      {
        name: "Raj Angad Bawa",
        role: "All-rounder",
        playercode: "20617",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/781.png",
      },
      {
        name: "Mayank Rawat",
        role: "All-rounder",
        playercode: "20617",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1228.png",
      },
      {
        name: "Krish Bhagat",
        role: "All-rounder",
        playercode: "20617",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/5034.png",
      },
      {
        name: "Corbin Bosch",
        role: "All-rounder",
        playercode: "20617",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1041.png",
      },
      {
        name: "Will Jacks",
        role: "All-rounder",
        playercode: "20617",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1941.png",
      },
      {
        name: "Shardul Thakur",
        role: "All-rounder",
        playercode: "20617",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/105.png",
      },
      {
        name: "Jasprit Bumrah",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2025/9.png",
      },
      {
        name: "Trent Boult",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/66.png",
      },
      {
        name: "Mayank Markande",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/87.png",
      },
      {
        name: "Deepak Chahar",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/91.png",
      },
      {
        name: "Ashwani Kumar",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3569.png",
      },
      {
        name: "Raghu Sharma",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3869.png",
      },
      {
        name: "Mohammad Izhar",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4545.png",
      },
      {
        name: "Keshav Maharaj",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/347.png",
      },
      {
        name: "Allah Ghazanfar",
        role: "Bowler",
        playercode: "20730",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2761.png",
      },
    ],
    bgImage: "https://4kwallpapers.com/images/walls/thumbs_3t/4934.png",
    textColor: "white",
    logo: "https://documents.iplt20.com/ipl/MI/Logos/Logooutline/MIoutline.png",
    displayName: "Mumbai Indians",
    trophyYears: "2013, 2015, 2017, 2019, 2020",
    officialSite: "https://www.mumbaiindians.com/",
    captain: "Hardik Pandya",
    coach: "Mahela Jayawardene",
    owner: "Indiawin Sports Pvt. Ltd",
    venue: "Wankhede Stadium",
  },
  "royal-challengers-bangalore": {
    players: [
      {
        name: "Rajat Patidar",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/597.png",
      },
      {
        name: "Devdutt Padikkal",
        role: "Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/200.png",
      },
      {
        name: "Virat Kohli",
        role: "Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2.png",
      },
      {
        name: "Phil Salt",
        role: "Wicketkeeper Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1220.png",
      },
      {
        name: "Jitesh Sharma",
        role: "Wicketkeeper Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1000.png",
      },
      {
        name: "Jordan Cox",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3372.png",
      },
      {
        name: "Krunal Pandya",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/17.png",
      },
      {
        name: "Swapnil Singh",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1483.png",
      },
      {
        name: "Tim David",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/636.png",
      },
      {
        name: "Romario Shepherd",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/371.png",
      },
      {
        name: "Jacob Bethell",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/869.png",
      },
      {
        name: "Venkatesh Iyer",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/584.png",
      },
      {
        name: "Satvik Deswal",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4555.png",
      },
      {
        name: "Mangesh Yadav",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4554.png",
      },
      {
        name: "Vicky Ostwal",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/786.png",
      },
      {
        name: "Vihaan Malhotra",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4012.png",
      },
      {
        name: "Kanishk Chouhan",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4016.png",
      },
      {
        name: "Josh Hazlewood",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/36.png",
      },
      {
        name: "Rasikh Dar",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/172.png",
      },
      {
        name: "Suyash Sharma",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1932.png",
      },
      {
        name: "Bhuvneshwar Kumar",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/15.png",
      },
      {
        name: "Nuwan Thushara",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/813.png",
      },
      {
        name: "Abhinandan Singh",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3574.png",
      },
      {
        name: "Jacob Duffy",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1701.png",
      },
      {
        name: "Yash Dayal",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/978.png",
      },
    ],
    bgImage: "https://4kwallpapers.com/images/walls/thumbs_3t/4937.png",
    textColor: "white",
    logo: "https://documents.iplt20.com/ipl/RCB/Logos/Logooutline/RCBoutline.png",
    displayName: "Royal Challengers Bengaluru",
    trophyYears: "2025, 2026",
    officialSite: "https://www.royalchallengers.com/",
    captain: "Rajat Patidar",
    coach: "Andy Flower",
    owner: "Royal Challengers Sports Private Ltd",
    venue: "M.Chinnaswamy Stadium",
  },
  "kolkata-knight-riders": {
    players: [
      {
        name: "Ajinkya Rahane",
        role: "Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/44.png",
      },
      {
        name: "Rinku Singh",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/152.png",
      },
      {
        name: "Angkrish Raghuvanshi",
        role: "Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/787.png",
      },
      {
        name: "Manish Pandey",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/16.png",
      },
      {
        name: "Finn Allen",
        role: "Wicketkeeper Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/595.png",
      },
      {
        name: "Tejasvi Singh",
        role: "Wicketkeeper Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4281.png",
      },
      {
        name: "Rahul Tripathi",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/188.png",
      },
      {
        name: "Tim Seifert",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/82.png",
      },
      {
        name: "Rovman Powell",
        role: "Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/329.png",
      },
      {
        name: "Anukul Roy",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/160.png",
      },
      {
        name: "Cameron Green",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/550.png",
      },
      {
        name: "Sarthak Ranjan",
        role: "All-rounder",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4203.png",
      },
      {
        name: "Daksh Kamra",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4548.png",
      },
      {
        name: "Rachin Ravindra",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/724.png",
      },
      {
        name: "Ramandeep Singh",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/991.png",
      },
      {
        name: "Sunil Narine",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/156.png",
      },
      {
        name: "Blessing Muzarabani",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/827.png",
      },
      {
        name: "Vaibhav Arora",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/583.png",
      },
      {
        name: "Matheesha Pathirana",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1014.png",
      },
      {
        name: "Kartik Tyagi",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/536.png",
      },
      {
        name: "Prashant Solanki",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/972.png",
      },
      {
        name: "Saurabh Dubey",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1010.png",
      },
      {
        name: "Navdeep Saini",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/207.png",
      },
      {
        name: "Umran Malik",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/637.png",
      },
      {
        name: "Varun Chakaravarthy",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/140.png",
      },
    ],
    bgImage: "https://4kwallpapers.com/images/walls/thumbs_3t/4940.png",
    textColor: "white",
    logo: "https://documents.iplt20.com/ipl/KKR/Logos/Logooutline/KKRoutline.png",
    displayName: "Kolkata Knight Riders",
    trophyYears: "2012, 2014, 2024",
    officialSite: "https://www.kkr.in/",
    captain: "Ajinkya Rahane",
    coach: "Abhishek Nayar",
    owner: "Knight Riders Sports Private Limited",
    venue: "Eden Gardens",
  },
  "delhi-capitals": {
    players: [
      {
        name: "KL Rahul",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/19.png",
      },
      {
        name: "Karun Nair",
        role: "Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/131.png",
      },
      {
        name: "David Miller",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/128.png",
      },
      {
        name: "Pathum Nissanka",
        role: "Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/618.png",
      },
      {
        name: "Sahil Parakh",
        role: "Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4542.png",
      },
      {
        name: "Prithvi Shaw",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/51.png",
      },
      {
        name: "Abishek Porel",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1580.png",
      },
      {
        name: "Tristan Stubbs",
        role: "Wicketkeeper Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1017.png",
      },
      {
        name: "Axar Patel",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/110.png",
      },
      {
        name: "Sameer Rizvi",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1229.png",
      },
      {
        name: "Ashutosh Sharma",
        role: "All-rounder",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3109.png",
      },
      {
        name: "Vipraj Nigam",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3560.png",
      },
      {
        name: "Ajay Mandal",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1931.png",
      },
      {
        name: "Tripurana Vijay",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3563.png",
      },
      {
        name: "Madhav Tiwari",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3561.png",
      },
      {
        name: "Nitish Rana",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/148.png",
      },
      {
        name: "Mitchell Starc",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/31.png",
      },
      {
        name: "T. Natarajan",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/224.png",
      },
      {
        name: "Mukesh Kumar",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1462.png",
      },
      {
        name: "Dushmantha Chameera",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/608.png",
      },
      {
        name: "Auqib Nabi",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4543.png",
      },
      {
        name: "Lungisani Ngidi",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/99.png",
      },
      {
        name: "Kyle Jamieson",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/382.png",
      },
      {
        name: "Rehan Ahmed",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/874.png",
      },
      {
        name: "Kuldeep Yadav",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/14.png",
      },
    ],
    bgImage:
      "https://i.pinimg.com/736x/33/1a/5a/331a5a63cf1b7f78f53433ae778e1ca3.jpg",
    textColor: "white",
    logo: "https://documents.iplt20.com/ipl/DC/Logos/LogoOutline/DCoutline.png",
    displayName: "Delhi Capitals",
    trophyYears: "🤡 🍭",
    officialSite: "https://www.delhicapitals.in/",
    captain: "Rishabh Pant",
    coach: "Ricky Ponting",
    owner: "GMR Group & JSW Group",
    venue: "Arun Jaitley Stadium",
  },
  "sunrisers-hyderabad": {
    players: [
      {
        name: "Ishan Kishan",
        role: "Wicketkeeper Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/164.png",
      },
      {
        name: "Aniket Verma",
        role: "Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3576.png",
      },
      {
        name: "Smaran Ravichandran",
        role: "Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3752.png",
      },
      {
        name: "Salil Arora",
        role: "Wicketkeeper Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4556.png",
      },
      {
        name: "Heinrich Klaasen",
        role: "Wicketkeeper Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/202.png",
      },
      {
        name: "Travis Head",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/37.png",
      },
      {
        name: "Harshal Patel",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/114.png",
      },
      {
        name: "Kamindu Mendis",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/627.png",
      },
      {
        name: "Harsh Dubey",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1494.png",
      },
      {
        name: "Shivang Kumar",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4561.png",
      },
      {
        name: "Krains Fuletra",
        role: "All-rounder",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4557.png",
      },
      {
        name: "Liam Livingstone",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/183.png",
      },
      {
        name: "R.S Ambrish",
        role: "All-rounder",
        playercode: "135",
        image: "",
      },
      {
        name: "Abhishek Sharma",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/212.png",
      },
      {
        name: "Nitish Kumar Reddy",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1944.png",
      },
      {
        name: "Pat Cummins",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/33.png",
      },
      {
        name: "Zeeshan Ansari",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3575.png",
      },
      {
        name: "Jaydev Unadkat",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/180.png",
      },
      {
        name: "Eshan Malinga",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3339.png",
      },
      {
        name: "Sakib Hussain",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3104.png",
      },
      {
        name: "Onkar Tarmale",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4560.png",
      },
      {
        name: "Amit Kumar",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4559.png",
      },
      {
        name: "Praful Hinge",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4558.png",
      },
      {
        name: "Dilshan Madushanka",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1018.png",
      },
      {
        name: "Gerald Coetzee",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2535.png",
      },
    ],
    bgImage:
      "https://wallpapers.com/images/high/sunrisers-hyderabad-orange-and-white-logo-die68jcmuvtg8iir.webp",
    textColor: "black",
    logo: "https://documents.iplt20.com/ipl/SRH/Logos/Logooutline/SRHoutline.png",
    displayName: "Sunrisers Hyderabad",
    trophyYears: "2016",
    officialSite: "https://www.sunrisershyderabad.in/",
    captain: "Pat Cummins",
    coach: "Daniel Vettori",
    owner: "Sun TV Network Limited",
    venue: "Rajiv Gandhi International Cricket Stadium",
  },
  "punjab-kings": {
    players: [
      {
        name: "Shreyas Iyer",
        role: "Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/12.png",
      },
      {
        name: "Nehal Wadhera",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1541.png",
      },
      {
        name: "Vishnu Vinod",
        role: "Wicketkeeper Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/581.png",
      },
      {
        name: "Harnoor Pannu",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/784.png",
      },
      {
        name: "Pyla Avinash",
        role: "Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3573.png",
      },
      {
        name: "Prabhsimran Singh",
        role: "Wicketkeeper Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/137.png",
      },
      {
        name: "Shashank Singh",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/191.png",
      },
      {
        name: "Marcus Stoinis",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/23.png",
      },
      {
        name: "Harpreet Brar",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/130.png",
      },
      {
        name: "Marco Jansen",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/586.png",
      },
      {
        name: "Azmatullah Omarzai",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1354.png",
      },
      {
        name: "Priyansh Arya",
        role: "All-rounder",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3571.png",
      },
      {
        name: "Musheer Khan",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2813.png",
      },
      {
        name: "Suryansh Shedge",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2146.png",
      },
      {
        name: "Mitch Owen",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3870.png",
      },
      {
        name: "Cooper Connolly",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/848.png",
      },
      {
        name: "Ben Dwarshuis",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/632.png",
      },
      {
        name: "Arshdeep Singh",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/125.png",
      },
      {
        name: "Yuzvendra Chahal",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/10.png",
      },
      {
        name: "Vyshak Vijaykumar",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2034.png",
      },
      {
        name: "Yash Thakur",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1550.png",
      },
      {
        name: "Xavier Bartlett",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3572.png",
      },
      {
        name: "Pravin Dubey",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/548.png",
      },
      {
        name: "Vishal Nishad",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4547.png",
      },
      {
        name: "Lockie Ferguson",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/69.png",
      },
    ],
    bgImage:
      "https://i.pinimg.com/736x/58/6e/a0/586ea0e5338219f6d4cebda77d789932.jpg",
    textColor: "white",
    logo: "https://documents.iplt20.com/ipl/PBKS/Logos/Logooutline/PBKSoutline.png",
    displayName: "Punjab Kings",
    trophyYears: "🤡 🍭",
    officialSite: "https://www.punjabkingsipl.in/",
    captain: "Shreyas Iyer",
    coach: "Ricky Ponting",
    owner: "K.P.H. Dream Cricket Private Limited",
    venue: "New International Cricket Stadium",
  },
  "rajasthan-royals": {
    players: [
      {
        name: "Shubham Dubey",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3112.png",
      },
      {
        name: "Vaibhav Sooryavanshi",
        role: "Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3498.png",
      },
      {
        name: "Donovan Ferreira",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2033.png",
      },
      {
        name: "Lhuan-dre Pretorious",
        role: "Wicketkeeper Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2827.png",
      },
      {
        name: "Ravi Singh",
        role: "Wicketkeeper Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4550.png",
      },
      {
        name: "Aman Rao Perala",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4552.png",
      },
      {
        name: "Shimron Hetmyer",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/210.png",
      },
      {
        name: "Yashasvi Jaiswal",
        role: "Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/533.png",
      },
      {
        name: "Dhruv Jurel",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1004.png",
      },
      {
        name: "Riyan Parag",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/189.png",
      },
      {
        name: "Yudhvir Singh Charak",
        role: "All-rounder",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/587.png",
      },
      {
        name: "Ravindra Jadeja",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/46.png",
      },
      {
        name: "Dasun Shanaka",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/375.png",
      },
      {
        name: "Jofra Archer",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/181.png",
      },
      {
        name: "Tushar Deshpande",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/539.png",
      },
      {
        name: "Kwena Maphaka",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/801.png",
      },
      {
        name: "Ravi Bishnoi",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/520.png",
      },
      {
        name: "Sushant Mishra",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1016.png",
      },
      {
        name: "Yash Raj Punja",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4553.png",
      },
      {
        name: "Vignesh Puthur",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3566.png",
      },
      {
        name: "Brijesh Sharma",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4551.png",
      },
      {
        name: "Adam Milne",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/157.png",
      },
      {
        name: "Kuldeep Sen",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1005.png",
      },
      {
        name: "Sandeep Sharma",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/220.png",
      },
      {
        name: "Nandre Burger",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2806.png",
      },
    ],
    bgImage:
      "https://wallpapers.com/images/high/rajasthan-royals-pink-background-pq1ac3zfrvq4wy4f.webp",
    textColor: "black",
    logo: "https://documents.iplt20.com/ipl/RR/Logos/Logooutline/RRoutline.png",
    displayName: "Rajasthan Royals",
    trophyYears: "2008",
    officialSite: "https://www.rajasthanroyals.com/",
    captain: "Riyan Parag",
    coach: "Kumar Sangakkara",
    owner: "Royal Multisport Private Limited",
    venue: "Sawai Mansingh Stadium",
  },
  "gujarat-titans": {
    players: [
      {
        name: "Shubman Gill",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/62.png",
      },
      {
        name: "Jos Buttler",
        role: "Wicketkeeper Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/182.png",
      },
      {
        name: "Kumar Kushagra",
        role: "Wicketkeeper Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3101.png",
      },
      {
        name: "Anuj Rawat",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/534.png",
      },
      {
        name: "Connor Esterhuizen",
        role: "Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/5035.png",
      },
      {
        name: "Glenn Phillips",
        role: "Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/635.png",
      },
      {
        name: "Sai Sudharsan",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/976.png",
      },
      {
        name: "Nishant Sindhu",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/791.png",
      },
      {
        name: "Washington Sundar",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/20.png",
      },
      {
        name: "Mohd. Arshad Khan",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/988.png",
      },
      {
        name: "Sai Kishore",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/544.png",
      },
      {
        name: "Jayant Yadav",
        role: "All-rounder",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/165.png",
      },
      {
        name: "Jason Holder",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/263.png",
      },
      {
        name: "Rahul Tewatia",
        role: "All-rounder",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/120.png",
      },
      {
        name: "Shahrukh Khan",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/590.png",
      },
      {
        name: "Kagiso Rabada",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/116.png",
      },
      {
        name: "Mohammed Siraj",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/63.png",
      },
      {
        name: "Prasidh Krishna",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/150.png",
      },
      {
        name: "Manav Suthar",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2443.png",
      },
      {
        name: "Gurnoor Singh Brar",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1231.png",
      },
      {
        name: "Ishant Sharma",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/50.png",
      },
      {
        name: "Ashok Sharma",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/980.png",
      },
      {
        name: "Luke Wood",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3116.png",
      },
      {
        name: "Kulwant Khejroliya",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/204.png",
      },
      {
        name: "Rashid Khan",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/218.png",
      },
    ],
    bgImage: "https://wallpapercave.com/wp/wp11073261.jpg",
    textColor: "white",
    logo: "https://documents.iplt20.com/ipl/GT/Logos/Logooutline/GToutline.png",
    displayName: "Gujarat Titans",
    trophyYears: "2022",
    officialSite: "https://www.gujarattitans.com/",
    captain: "Shubman Gill",
    coach: "Ashish Nehra",
    owner: "Torrent Gujarat Titans Private Limited",
    venue: "Narendra Modi Stadium",
  },
  "lucknow-super-giants": {
    players: [
      {
        name: "Rishabh Pant",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/18.png",
      },
      {
        name: "Aiden Markram",
        role: "Batter",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/287.png",
      },
      {
        name: "Himmat Singh",
        role: "Batter",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/203.png",
      },
      {
        name: "Matthew Breetzke",
        role: "Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2805.png",
      },
      {
        name: "Mukul Choudhary",
        role: "Wicketkeeper Batter",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/4549.png",
      },
      {
        name: "Akshat Raghuwanshi",
        role: "Batter",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1487.png",
      },
      {
        name: "Josh Inglis",
        role: "Wicketkeeper Batter",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/647.png",
      },
      {
        name: "Nicholas Pooran",
        role: "Wicketkeeper Batter",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/136.png",
      },
      {
        name: "Mitchell Marsh",
        role: "All-rounder",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/40.png",
      },
      {
        name: "Abdul Samad",
        role: "All-rounder",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/525.png",
      },
      {
        name: "Shahbaz Ahamad",
        role: "All-rounder",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/523.png",
      },
      {
        name: "Arshin Kulkarni",
        role: "All-rounder",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2788.png",
      },
      {
        name: "Ayush Badoni",
        role: "All-rounder",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/985.png",
      },
      {
        name: "Mohammad Shami",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/47.png",
      },
      {
        name: "Avesh Khan",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/109.png",
      },
      {
        name: "M. Siddharth",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/532.png",
      },
      {
        name: "Digvesh Singh",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/3565.png",
      },
      {
        name: "Akash Singh",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/535.png",
      },
      {
        name: "Prince Yadav",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/1225.png",
      },
      {
        name: "Arjun Tendulkar",
        role: "Bowler",
        playercode: "140",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/585.png",
      },
      {
        name: "Anrich Nortje",
        role: "Bowler",
        playercode: "9",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/142.png",
      },
      {
        name: "Naman Tiwari",
        role: "Bowler",
        playercode: "135",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/2801.png",
      },
      {
        name: "George Linde",
        role: "Bowler",
        playercode: "1",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/340.png",
      },
      {
        name: "Mayank Yadav",
        role: "Bowler",
        playercode: "1735",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/987.png",
      },
      {
        name: "Mohsin Khan",
        role: "Bowler",
        playercode: "5612",
        image: "https://documents.iplt20.com/ipl/IPLHeadshot2026/541.png",
      },
    ],
    bgImage:
      "https://imgk.timesnownews.com/media/Lucknow_Super_Giants_logo_1.png",
    textColor: "black",
    logo: "https://documents.iplt20.com/ipl/LSG/Logos/Logooutline/LSGoutline.png",
    displayName: "Lucknow Super Giants",
    trophyYears: "🤡 🍭",
    officialSite: "https://www.lucknowsupergiants.in/",
    captain: "Rishabh Pant",
    coach: "Justin Langer",
    owner: "RPSG Sports Private Limited",
    venue: "BRSABV Ekana Cricket Stadium",
  },
};

const Players = () => {
  const { teamname } = useParams();
  const [loading, setLoading] = useState(true);
  const data = teamData[teamname] || teamData["chennai-super-kings"];
  const players = data.players;
  const { bgImage, textColor } = data;

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [teamname]);

  const batters = players.filter(
    (player) =>
      player.role.includes("Batter") ||
      player.role.includes("Wicketkeeper Batter"),
  );
  const allRounders = players.filter((player) =>
    player.role.includes("All-rounder"),
  );
  const bowlers = players.filter((player) => player.role.includes("Bowler"));

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="container mt-6 lg:m-6">
      {/* Team Details Section */}
      <div className="p-6 mb-8 bg-gradient-to-r from-blue-900 to-indigo-900 rounded-xl shadow-xl">
        <div className="flex flex-col gap-8 md:flex-row">
          {/* Left Side: Logo and Basic Info */}
          <div className="flex-1">
            <div className="flex gap-6 items-center mb-4">
              <img src={data.logo} alt={data.displayName} className="h-24" />
              <div>
                <h1 className="text-3xl font-bold text-white">
                  {data.displayName}
                </h1>
                {data.trophyYears && (
                  <div className="flex gap-2 items-center mt-2 text-yellow-400">
                    <span className="text-2xl">🏆</span>
                    <span className="font-medium">{data.trophyYears}</span>
                  </div>
                )}
              </div>
            </div>
            <a
              href={data.officialSite}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex gap-2 items-center px-6 py-2 font-medium text-white bg-red-500 rounded-lg transition-colors hover:bg-red-600"
            >
              Official Team Site
              <span className="text-lg">↗</span>
            </a>
          </div>

          {/* Right Side: Team Details */}
          <div className="grid flex-1 grid-cols-1 gap-3">
            <div className="px-4 py-3 rounded-lg backdrop-blur-sm bg-white/10">
              <span className="font-semibold text-yellow-400">Captain - </span>
              <span className="text-white">{data.captain}</span>
            </div>
            <div className="px-4 py-3 rounded-lg backdrop-blur-sm bg-white/10">
              <span className="font-semibold text-yellow-400">Coach - </span>
              <span className="text-white">{data.coach}</span>
            </div>
            <div className="px-4 py-3 rounded-lg backdrop-blur-sm bg-white/10">
              <span className="font-semibold text-yellow-400">Owner - </span>
              <span className="text-white">{data.owner}</span>
            </div>
            <div className="px-4 py-3 rounded-lg backdrop-blur-sm bg-white/10">
              <span className="font-semibold text-yellow-400">Venue - </span>
              <span className="text-white">{data.venue}</span>
            </div>
          </div>
        </div>
      </div>

      {/* CSK History Section */}
      {teamname === "chennai-super-kings" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-yellow-900 to-yellow-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Chennai Super Kings – Full IPL History
          </h2>

          <section className="mb-8">
            <p className="mb-4 text-lg">
              Chennai Super Kings (CSK) is one of the most successful and most
              loved franchises in the history of the Indian Premier League. The
              team was founded in 2008 and is owned by Chennai Super Kings
              Cricket Limited. Their home ground is the iconic M. A. Chidambaram
              Stadium, also called Chepauk.
            </p>
            <div className="mb-4">
              <h3 className="mb-2 text-xl font-semibold">
                The team is famous for:
              </h3>
              <ul className="space-y-1 list-disc list-inside">
                <li>Yellow jersey (“Yellow Army”)</li>
                <li>Massive fan following</li>
                <li>Calm leadership of MS Dhoni</li>
                <li>Consistency in playoffs and finals</li>
                <li>Strong experienced players and smart tactics</li>
              </ul>
            </div>
            <p className="text-lg">
              CSK is jointly the most successful IPL team with 5 IPL titles.
            </p>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">CSK IPL Trophy Years</h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-yellow-800/50">
                <thead>
                  <tr className="border-b border-yellow-500">
                    <th className="p-3 text-left">Year</th>
                    <th className="p-3 text-left">Captain</th>
                    <th className="p-3 text-left">Opponent in Final</th>
                    <th className="p-3 text-left">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-yellow-500/50">
                    <td className="p-3">2010</td>
                    <td className="p-3">MS Dhoni</td>
                    <td className="p-3">Mumbai Indians</td>
                    <td className="p-3">Won by 22 runs</td>
                  </tr>
                  <tr className="border-b border-yellow-500/50">
                    <td className="p-3">2011</td>
                    <td className="p-3">MS Dhoni</td>
                    <td className="p-3">Royal Challengers Bengaluru</td>
                    <td className="p-3">Won by 58 runs</td>
                  </tr>
                  <tr className="border-b border-yellow-500/50">
                    <td className="p-3">2018</td>
                    <td className="p-3">MS Dhoni</td>
                    <td className="p-3">Sunrisers Hyderabad</td>
                    <td className="p-3">Won by 8 wickets</td>
                  </tr>
                  <tr className="border-b border-yellow-500/50">
                    <td className="p-3">2021</td>
                    <td className="p-3">MS Dhoni</td>
                    <td className="p-3">Kolkata Knight Riders</td>
                    <td className="p-3">Won by 27 runs</td>
                  </tr>
                  <tr>
                    <td className="p-3">2023</td>
                    <td className="p-3">MS Dhoni</td>
                    <td className="p-3">Gujarat Titans</td>
                    <td className="p-3">Won by 5 wickets (DLS)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Early Years (2008–2009)</h3>
            <ul className="space-y-2 list-disc list-inside">
              <li>CSK was formed in 2008.</li>
              <li>MS Dhoni became captain from the first season.</li>
              <li>
                Star players included: Suresh Raina, Matthew Hayden, Muttiah
                Muralitharan, Albie Morkel
              </li>
            </ul>
            <div className="mt-4">
              <h4 className="mb-2 text-xl font-semibold">2008</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Reached the IPL Final in their debut season.</li>
                <li>Lost to Rajasthan Royals.</li>
              </ul>
            </div>
            <div className="mt-4">
              <h4 className="mb-2 text-xl font-semibold">2009</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Reached semifinal.</li>
                <li>Became known for consistency.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">First IPL Trophy – 2010</h3>
            <p className="mb-4">2010 changed CSK history forever.</p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key stars:</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Suresh Raina</li>
                <li>Murali Vijay</li>
                <li>Doug Bollinger</li>
              </ul>
            </div>
            <p>
              CSK defeated Mumbai Indians in the final and won their first IPL
              title. They also won the Champions League Twenty20 in the same
              year.
            </p>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Back-to-Back Champions – 2011
            </h3>
            <p className="mb-4">
              CSK became the first IPL team to win consecutive titles.
            </p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Highlights:</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Murali Vijay scored 95 in the final.</li>
                <li>Beat Royal Challengers Bengaluru by 58 runs.</li>
                <li>Dominated world T20 cricket during this period.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Finals and Consistency Era (2012–2015)
            </h3>
            <p className="mb-4">CSK became the most consistent IPL team.</p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">
                Important achievements
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Reached multiple finals.</li>
                <li>
                  Strong core team: Ravindra Jadeja, Dwayne Bravo, Faf du
                  Plessis, Ravichandran Ashwin
                </li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">2013 & 2015 Finals</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Lost both finals to Mumbai Indians.</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">
                Suspension (2016–2017)
              </h4>
              <p>
                CSK was suspended for two IPL seasons due to issues linked with
                the 2013 betting and spot-fixing case involving franchise
                officials.
              </p>
            </div>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Legendary Comeback – 2018
            </h3>
            <p className="mb-4">
              After a two-year suspension, CSK returned in 2018. People called
              them “Dad’s Army” because many players were experienced veterans.
              But CSK shocked everyone.
            </p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Shane Watson</li>
                <li>Ambati Rayudu</li>
                <li>Dwayne Bravo</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Final</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Shane Watson scored 117* in the final.</li>
                <li>CSK defeated Sunrisers Hyderabad.</li>
                <li>One of the greatest comeback stories in IPL history.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              2019 – One Run Heartbreak
            </h3>
            <p className="mb-4">
              CSK reached another final against Mumbai Indians. They lost by
              just 1 run in one of the closest IPL finals ever.
            </p>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Fourth Trophy – 2021</h3>
            <p className="mb-4">
              After a poor 2020 season, many thought CSK was finished. But they
              came back strongly in 2021.
            </p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Ruturaj Gaikwad</li>
                <li>Faf du Plessis</li>
                <li>Moeen Ali</li>
              </ul>
            </div>
            <p>CSK defeated Kolkata Knight Riders in the final.</p>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Fifth Trophy – 2023</h3>
            <p className="mb-4">
              The 2023 title was emotional because many believed it could be the
              last season of MS Dhoni.
            </p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Ruturaj Gaikwad</li>
                <li>Devon Conway</li>
                <li>Ravindra Jadeja</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Famous Moment</h4>
              <p className="mb-2">In the last 2 balls:</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>Jadeja hit a six</li>
                <li>Then a four</li>
              </ul>
            </div>
            <p>CSK defeated Gujarat Titans and lifted their 5th IPL trophy.</p>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              CSK Captains Through History
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-yellow-800/50">
                <thead>
                  <tr className="border-b border-yellow-500">
                    <th className="p-3 text-left">Captain</th>
                    <th className="p-3 text-left">Years</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-yellow-500/50">
                    <td className="p-3">MS Dhoni</td>
                    <td className="p-3">2008–2023, 2025</td>
                  </tr>
                  <tr className="border-b border-yellow-500/50">
                    <td className="p-3">Suresh Raina</td>
                    <td className="p-3">Stand-in captain</td>
                  </tr>
                  <tr className="border-b border-yellow-500/50">
                    <td className="p-3">Ravindra Jadeja</td>
                    <td className="p-3">2022</td>
                  </tr>
                  <tr>
                    <td className="p-3">Ruturaj Gaikwad</td>
                    <td className="p-3">2024–present</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Biggest CSK Legends</h3>
            <p className="mb-4">Some iconic CSK players:</p>
            <ul className="space-y-1 list-disc list-inside">
              <li>MS Dhoni</li>
              <li>Suresh Raina</li>
              <li>Ravindra Jadeja</li>
              <li>Dwayne Bravo</li>
              <li>Ruturaj Gaikwad</li>
              <li>Faf du Plessis</li>
              <li>Shane Watson</li>
            </ul>
          </section>

          <hr className="mb-8 border-yellow-500" />

          <section>
            <h3 className="mb-4 text-2xl font-bold">Major CSK Records</h3>
            <ul className="space-y-2 list-disc list-inside">
              <li>5 IPL trophies</li>
              <li>10 IPL finals appearances</li>
              <li>12 playoff qualifications</li>
              <li>2 Champions League T20 titles</li>
              <li>One of the highest fan-followed teams in cricket history</li>
            </ul>
          </section>
        </div>
      )}

      {/* Mumbai Indians History Section */}
      {teamname === "mumbai-indians" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-blue-900 to-blue-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Mumbai Indians – Full IPL Trophy History
          </h2>

          <section className="mb-8">
            <p className="mb-4 text-lg">
              Mumbai Indians (MI) is one of the most successful teams in the
              history of the Indian Premier League. Owned by Reliance Industries
              through Indiawin Sports, MI is famous for its strong squad,
              comeback mentality, and championship-winning captaincy under Rohit
              Sharma.
            </p>
            <div className="mb-4">
              <h3 className="mb-2 text-xl font-semibold">
                They won IPL titles in:
              </h3>
              <ul className="space-y-1 list-disc list-inside">
                <li>🏆 2013</li>
                <li>🏆 2015</li>
                <li>🏆 2017</li>
                <li>🏆 2019</li>
                <li>🏆 2020</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL 2013 – First Title
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Captain</h4>
              <p>Rohit Sharma</p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Coach</h4>
              <p>John Wright</p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>MI vs Chennai Super Kings</li>
                <li>Venue: Eden Gardens</li>
                <li>MI won by 23 runs</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Kieron Pollard</li>
                <li>Lasith Malinga</li>
                <li>Dwayne Smith</li>
                <li>Harbhajan Singh</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Season Highlights</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Rohit Sharma became captain mid-season and transformed MI.
                </li>
                <li>Pollard dominated with all-round performances.</li>
                <li>Malinga’s death bowling was deadly.</li>
                <li>MI won their first-ever IPL trophy.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL 2015 – Second Title
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>MI vs Chennai Super Kings</li>
                <li>Venue: Eden Gardens</li>
                <li>MI won by 41 runs</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Lendl Simmons</li>
                <li>Rohit Sharma</li>
                <li>Kieron Pollard</li>
                <li>Mitchell McClenaghan</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Season Highlights</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>MI started poorly but made a stunning comeback.</li>
                <li>Lendl Simmons gave explosive starts.</li>
                <li>Strong bowling unit helped MI dominate playoffs.</li>
                <li>
                  Rohit became the first MI captain to win multiple IPL titles.
                </li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL 2017 – Third Title
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>MI vs Rising Pune Supergiant</li>
                <li>Venue: Rajiv Gandhi International Cricket Stadium</li>
                <li>MI won by just 1 run</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Jasprit Bumrah</li>
                <li>Krunal Pandya</li>
                <li>Hardik Pandya</li>
                <li>Mitchell Johnson</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Season Highlights</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>One of the greatest IPL finals ever.</li>
                <li>Krunal Pandya’s 47 in the final changed the match.</li>
                <li>Bumrah became MI’s bowling superstar.</li>
                <li>Johnson defended the last over brilliantly.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL 2019 – Fourth Title
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>MI vs Chennai Super Kings</li>
                <li>Venue: Rajiv Gandhi International Cricket Stadium</li>
                <li>MI won by 1 run</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Jasprit Bumrah</li>
                <li>Lasith Malinga</li>
                <li>Quinton de Kock</li>
                <li>Hardik Pandya</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Season Highlights</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Malinga bowled the iconic final ball to dismiss Shardul
                  Thakur.
                </li>
                <li>Bumrah delivered one of the best bowling seasons.</li>
                <li>MI became the first team to win 4 IPL trophies.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL 2020 – Fifth Title
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>MI vs Delhi Capitals</li>
                <li>Venue: Dubai International Stadium</li>
                <li>MI won by 5 wickets</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Trent Boult</li>
                <li>Ishan Kishan</li>
                <li>Suryakumar Yadav</li>
                <li>Rohit Sharma</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Season Highlights</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>IPL was held in UAE due to COVID-19.</li>
                <li>MI dominated almost every team throughout the season.</li>
                <li>
                  Rohit Sharma became the most successful IPL captain at that
                  time.
                </li>
                <li>MI became the first franchise to win 5 IPL trophies.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🔥 Mumbai Indians Legacy
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">
                Why MI Became So Successful
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Strong scouting system for young talent</li>
                <li>World-class fast bowling attack</li>
                <li>Match winners in every season</li>
                <li>Calm leadership of Rohit Sharma</li>
                <li>Excellent finishing players like Pollard and Hardik</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">
                Legendary MI Players
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Rohit Sharma</li>
                <li>Kieron Pollard</li>
                <li>Lasith Malinga</li>
                <li>Jasprit Bumrah</li>
                <li>Hardik Pandya</li>
                <li>Suryakumar Yadav</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Home Ground</h4>
              <p>Wankhede Stadium</p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">IPL Titles</h4>
              <div className="overflow-x-auto">
                <table className="w-full rounded-lg bg-blue-800/50">
                  <thead>
                    <tr className="border-b border-blue-500">
                      <th className="p-3 text-left">Year</th>
                      <th className="p-3 text-left">Opponent in Final</th>
                      <th className="p-3 text-left">Result</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-blue-500/50">
                      <td className="p-3">2013</td>
                      <td className="p-3">CSK</td>
                      <td className="p-3">Won by 23 runs</td>
                    </tr>
                    <tr className="border-b border-blue-500/50">
                      <td className="p-3">2015</td>
                      <td className="p-3">CSK</td>
                      <td className="p-3">Won by 41 runs</td>
                    </tr>
                    <tr className="border-b border-blue-500/50">
                      <td className="p-3">2017</td>
                      <td className="p-3">RPS</td>
                      <td className="p-3">Won by 1 run</td>
                    </tr>
                    <tr className="border-b border-blue-500/50">
                      <td className="p-3">2019</td>
                      <td className="p-3">CSK</td>
                      <td className="p-3">Won by 1 run</td>
                    </tr>
                    <tr>
                      <td className="p-3">2020</td>
                      <td className="p-3">DC</td>
                      <td className="p-3">Won by 5 wickets</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p className="text-lg">
              🔥 Mumbai Indians is widely considered one of the greatest T20
              franchises ever because of its consistency, clutch performances,
              and championship mentality.
            </p>
          </section>
        </div>
      )}

      {/* Kolkata Knight Riders History Section */}
      {teamname === "kolkata-knight-riders" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-purple-900 to-purple-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Kolkata Knight Riders (KKR) – Full IPL Trophy History
          </h2>

          <section className="mb-8">
            <h3 className="mb-4 text-xl font-semibold">Team Introduction</h3>
            <p className="mb-4 text-lg">
              Kolkata Knight Riders is one of the most popular franchises in the
              Indian Premier League. The team represents Kolkata and is owned
              by:
            </p>
            <ul className="mb-4 space-y-1 list-disc list-inside">
              <li>Shah Rukh Khan</li>
              <li>Juhi Chawla</li>
              <li>Jay Mehta</li>
            </ul>
            <div>
              <h4 className="mb-2 text-lg font-semibold">Home Ground</h4>
              <p>
                Eden Gardens - One of the biggest and most iconic cricket
                stadiums in the world.
              </p>
            </div>
          </section>

          <hr className="mb-8 border-purple-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL Titles Won by KKR
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-purple-800/50">
                <thead>
                  <tr className="border-b border-purple-500">
                    <th className="p-3 text-left">Year</th>
                    <th className="p-3 text-left">Captain</th>
                    <th className="p-3 text-left">Opponent in Final</th>
                    <th className="p-3 text-left">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-purple-500/50">
                    <td className="p-3">2012</td>
                    <td className="p-3">Gautam Gambhir</td>
                    <td className="p-3">Chennai Super Kings</td>
                    <td className="p-3">Won by 5 wickets</td>
                  </tr>
                  <tr className="border-b border-purple-500/50">
                    <td className="p-3">2014</td>
                    <td className="p-3">Gautam Gambhir</td>
                    <td className="p-3">Kings XI Punjab</td>
                    <td className="p-3">Won by 3 wickets</td>
                  </tr>
                  <tr>
                    <td className="p-3">2024</td>
                    <td className="p-3">Shreyas Iyer</td>
                    <td className="p-3">Sunrisers Hyderabad</td>
                    <td className="p-3">Won by 8 wickets</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <hr className="mb-8 border-purple-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL 2012 – First Championship
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Season Overview</h4>
              <p className="mb-4">
                The 2012 season changed KKR’s history forever. Under captain{" "}
                <strong>Gautam Gambhir</strong>, the team became disciplined,
                aggressive, and consistent.
              </p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Gautam Gambhir</li>
                <li>Sunil Narine</li>
                <li>Jacques Kallis</li>
                <li>Yusuf Pathan</li>
                <li>Manvinder Bisla</li>
                <li>Brett Lee</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Final: KKR vs Chennai Super Kings</li>
                <li>Venue: M. A. Chidambaram Stadium</li>
              </ul>
              <h4 className="mb-2 text-xl font-semibold">Match Summary</h4>
              <p className="mb-4">
                CSK scored <strong>190/3</strong> with a brilliant innings from
                Suresh Raina.
              </p>
              <p className="mb-4">KKR chased the target successfully:</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Manvinder Bisla scored <strong>89 runs</strong>
                </li>
                <li>Jacques Kallis added important runs</li>
                <li>
                  KKR won their <strong>first IPL trophy</strong>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Major Highlight</h4>
              <p>
                Sunil Narine’s mystery spin became one of the biggest reasons
                behind KKR’s success.
              </p>
            </div>
          </section>

          <hr className="mb-8 border-purple-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL 2014 – Second Championship
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Season Overview</h4>
              <p className="mb-4">
                KKR had a slow start but later created history by winning{" "}
                <strong>9 consecutive matches</strong>.
              </p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Gautam Gambhir</li>
                <li>Robin Uthappa</li>
                <li>Manish Pandey</li>
                <li>Sunil Narine</li>
                <li>Andre Russell</li>
                <li>Piyush Chawla</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Final: KKR vs Punjab Kings (then Kings XI Punjab)</li>
                <li>Venue: M. Chinnaswamy Stadium</li>
              </ul>
              <h4 className="mb-2 text-xl font-semibold">Match Summary</h4>
              <p className="mb-4">
                Punjab scored <strong>199/4</strong> with Wriddhiman Saha
                scoring a century.
              </p>
              <p className="mb-4">KKR chased the huge total:</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Manish Pandey scored <strong>94 runs</strong>
                </li>
                <li>
                  KKR won by <strong>3 wickets</strong>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Major Highlight</h4>
              <p>
                Robin Uthappa won the Orange Cap and Sunil Narine dominated with
                the ball.
              </p>
            </div>
          </section>

          <hr className="mb-8 border-purple-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 IPL 2024 – Third Championship
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Season Overview</h4>
              <p className="mb-4">
                The 2024 season was one of the most dominant IPL campaigns ever
                by KKR.
              </p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Captain</h4>
              <p>Shreyas Iyer</p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Mentor</h4>
              <p>
                Gautam Gambhir returned as mentor and transformed the team
                mentality.
              </p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Sunil Narine</li>
                <li>Andre Russell</li>
                <li>Phil Salt</li>
                <li>Venkatesh Iyer</li>
                <li>Varun Chakravarthy</li>
                <li>Mitchell Starc</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Final: KKR vs Sunrisers Hyderabad</li>
                <li>Venue: M. A. Chidambaram Stadium</li>
              </ul>
              <h4 className="mb-2 text-xl font-semibold">Match Summary</h4>
              <p className="mb-4">KKR completely dominated the final:</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  SRH all out for <strong>113</strong>
                </li>
                <li>
                  KKR chased easily in just <strong>10.3 overs</strong>
                </li>
                <li>
                  Won by <strong>8 wickets</strong>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Major Highlight</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Sunil Narine delivered all-round performances throughout the
                  tournament.
                </li>
                <li>Andre Russell became a major match-winner again.</li>
                <li>Mitchell Starc dominated in playoffs.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-purple-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">KKR Legends</h3>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">Gautam Gambhir</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Most successful KKR captain</li>
                <li>Won 2 IPL trophies as captain</li>
                <li>Returned in 2024 as mentor and helped win another title</li>
              </ul>
            </div>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">Sunil Narine</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Greatest spinner in KKR history</li>
                <li>Match-winner with both bat and ball</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Andre Russell</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>One of the most destructive all-rounders in IPL history</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-purple-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              KKR Records & Achievements
            </h3>
            <ul className="space-y-2 list-disc list-inside">
              <li>
                🏆 IPL Titles: <strong>3</strong>
              </li>
              <li>
                🔥 Champions in: <strong>2012, 2014, 2024</strong>
              </li>
              <li>🏟 Home Stadium: Eden Gardens</li>
              <li>👑 Most Successful Captain: Gautam Gambhir</li>
              <li>💜 Team Colors: Purple & Gold</li>
              <li>🎶 Famous Motto: “Korbo Lorbo Jeetbo”</li>
            </ul>
          </section>

          <hr className="mb-8 border-purple-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Rivalries</h3>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">
                KKR vs Royal Challengers Bengaluru
              </h4>
              <p>
                One of IPL’s oldest rivalries. KKR won the very first IPL match
                in 2008 where Brendon McCullum scored 158*.
              </p>
            </div>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">
                KKR vs Mumbai Indians
              </h4>
              <p>A high-pressure rivalry featuring many close matches.</p>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">
                KKR vs Chennai Super Kings
              </h4>
              <p>Battle between two successful IPL franchises.</p>
            </div>
          </section>

          <hr className="mb-8 border-purple-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">KKR Trophy Timeline</h3>
            <pre className="p-4 rounded-lg bg-purple-950/50">
              2012 🏆 2014 🏆 2024 🏆
            </pre>
            <p className="mt-4 text-lg">
              💜 KKR became one of the strongest IPL franchises with three
              championships and a massive fanbase worldwide.
            </p>
          </section>
        </div>
      )}

      {/* Sunrisers Hyderabad History Section */}
      {teamname === "sunrisers-hyderabad" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-orange-900 to-orange-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Sunrisers Hyderabad – Complete IPL History
          </h2>

          <section className="mb-8">
            <h3 className="mb-4 text-xl font-semibold">Team Overview</h3>
            <ul className="space-y-2 list-disc list-inside">
              <li>
                <strong>Founded:</strong> 2012
              </li>
              <li>
                <strong>Owner:</strong> Sun TV Network
              </li>
              <li>
                <strong>Home Ground:</strong> Rajiv Gandhi International Cricket
                Stadium
              </li>
              <li>
                <strong>Team Colors:</strong> Orange & Black
              </li>
              <li>
                <strong>Nickname:</strong> <em>Orange Army</em>
              </li>
              <li>
                <strong>IPL Titles:</strong> <strong>1 (2016)</strong> 🏆
              </li>
            </ul>
          </section>

          <hr className="mb-8 border-orange-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Journey of SRH in IPL</h3>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">
                Formation of SRH (2012)
              </h4>
              <p className="mb-4">
                Sunrisers Hyderabad replaced the terminated franchise Deccan
                Chargers in 2012. The team officially started playing from the{" "}
                <strong>2013 IPL season</strong>.
              </p>
              <p>The franchise quickly became known for:</p>
              <ul className="mt-2 space-y-1 list-disc list-inside">
                <li>Strong bowling attacks</li>
                <li>Dependable overseas players</li>
                <li>Consistent playoff appearances</li>
                <li>Defensive cricket strategy</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-orange-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">IPL Seasons History</h3>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">2013 – Dream Start</h4>
              <p className="mb-2">
                <strong>Captain:</strong> Kumar Sangakkara / Cameron White
              </p>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Key Players</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Shikhar Dhawan</li>
                  <li>Dale Steyn</li>
                  <li>Amit Mishra</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Performance</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>
                    Finished <strong>4th</strong>
                  </li>
                  <li>Reached playoffs in debut season</li>
                  <li>Eliminated in Qualifier</li>
                </ul>
              </div>
              <p className="mt-4">
                SRH became famous for its deadly bowling unit led by Dale Steyn.
              </p>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2014 – Struggles in UAE + India Season
              </h4>
              <p className="mb-2">
                <strong>Captain:</strong> Shikhar Dhawan
              </p>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>
                    Finished <strong>6th</strong>
                  </li>
                  <li>Team struggled with batting inconsistency</li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2015 – Rebuilding Phase
              </h4>
              <p className="mb-2">
                <strong>Captain:</strong> David Warner
              </p>
              <p className="mb-4">
                This season marked the beginning of the Warner era.
              </p>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Key Players</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>David Warner</li>
                  <li>Bhuvneshwar Kumar</li>
                  <li>Moises Henriques</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>
                    Finished <strong>6th</strong>
                  </li>
                  <li>Warner emerged as SRH’s biggest superstar</li>
                </ul>
              </div>
            </div>
          </section>

          <hr className="mb-8 border-orange-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">🏆 2016 – IPL Champions</h3>
            <p className="mb-4">
              <strong>Captain:</strong> David Warner
            </p>
            <p className="mb-4">This was the greatest season in SRH history.</p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>David Warner</li>
                <li>Bhuvneshwar Kumar</li>
                <li>Yuvraj Singh</li>
                <li>Mustafizur Rahman</li>
                <li>Ben Cutting</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Final Match</h4>
              <h5 className="mb-2 text-lg font-semibold">
                2016 Indian Premier League Final
              </h5>
              <p className="mb-4">
                SRH defeated Royal Challengers Bengaluru in the final.
              </p>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>
                  SRH: <strong>208/7</strong>
                </li>
                <li>
                  RCB: <strong>200/7</strong>
                </li>
                <li>
                  Won by <strong>8 runs</strong>
                </li>
              </ul>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">
                  Hero of the Final
                </h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Ben Cutting’s explosive batting</li>
                  <li>Warner’s captaincy</li>
                  <li>Bhuvneshwar’s bowling</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">
                  Historic Achievement
                </h5>
                <p>
                  SRH became IPL champions only in their{" "}
                  <strong>4th season</strong>.
                </p>
              </div>
            </div>
          </section>

          <hr className="mb-8 border-orange-500" />

          <section className="mb-8">
            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2017 – Strong Defense
              </h4>
              <p className="mb-2">
                <strong>Captain:</strong> David Warner
              </p>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Reached playoffs</li>
                  <li>Eliminated in Eliminator</li>
                </ul>
              </div>
              <p className="mt-4">Warner won Orange Cap again.</p>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2018 – Runner-Up Season
              </h4>
              <p className="mb-2">
                <strong>Captain:</strong> Kane Williamson
              </p>
              <p className="mb-4">
                David Warner missed the season due to suspension.
              </p>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Star Performers</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Kane Williamson</li>
                  <li>Rashid Khan</li>
                  <li>Bhuvneshwar Kumar</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Finished Runner-Up</li>
                  <li>Lost final to Chennai Super Kings</li>
                </ul>
              </div>
              <p className="mt-4">
                Rashid Khan delivered one of the greatest all-round playoff
                performances in IPL history.
              </p>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2019 – Warner’s Comeback
              </h4>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Highlights</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Warner scored heavily again</li>
                  <li>Jonny Bairstow partnership became famous</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Reached playoffs</li>
                  <li>Eliminated in Eliminator</li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2020 – Another Playoff Run
              </h4>
              <p className="mb-2">
                <strong>Captain:</strong> David Warner
              </p>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Key Players</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Kane Williamson</li>
                  <li>Rashid Khan</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Finished 3rd</li>
                  <li>Lost in Qualifier 2</li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2021 – Major Decline
              </h4>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Problems</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Warner captaincy controversy</li>
                  <li>Poor batting form</li>
                  <li>Team instability</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Finished last</li>
                </ul>
              </div>
              <p className="mt-4">
                This season marked the end of the Warner era at SRH.
              </p>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2022 – New Era Begins
              </h4>
              <p className="mb-2">
                <strong>Captain:</strong> Kane Williamson
              </p>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">New Stars</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Umran Malik</li>
                  <li>Rahul Tripathi</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Mid-table finish</li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2023 – Struggling Season
              </h4>
              <p className="mb-2">
                <strong>Captain:</strong> Aiden Markram
              </p>
              <p className="mb-4">
                Despite a strong squad, SRH had a disappointing campaign.
              </p>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Result</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Finished near bottom</li>
                </ul>
              </div>
            </div>
          </section>

          <hr className="mb-8 border-orange-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              2024 – Explosive Batting Revolution
            </h3>
            <p className="mb-4">
              <strong>Captain:</strong> Pat Cummins
            </p>
            <p className="mb-4">
              SRH transformed into one of the most dangerous batting teams ever.
            </p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Travis Head</li>
                <li>Abhishek Sharma</li>
                <li>Heinrich Klaasen</li>
                <li>Pat Cummins</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Major Records</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Multiple <strong>250+ scores</strong>
                </li>
                <li>Broke IPL high-scoring records</li>
                <li>Ultra-aggressive powerplay batting</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Result</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Reached IPL Final</li>
                <li>Lost to Kolkata Knight Riders</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-orange-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">SRH Legends</h3>
            <div>
              <h4 className="mb-2 text-xl font-semibold">
                Greatest SRH Players
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>David Warner</li>
                <li>Bhuvneshwar Kumar</li>
                <li>Rashid Khan</li>
                <li>Kane Williamson</li>
                <li>Travis Head</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-orange-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">SRH Records</h3>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Team Records</h4>
              <ul className="space-y-2 list-disc list-inside">
                <li>
                  🏆 IPL Titles: <strong>1</strong>
                </li>
                <li>
                  🥈 Runner-Up: <strong>2018, 2024</strong>
                </li>
                <li>
                  🔥 Highest Team Score: <strong>287/3</strong> (IPL record
                  during 2024 season)
                </li>
                <li>
                  🎯 Known For: World-class bowling & explosive opening batting
                </li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-orange-500" />

          <section>
            <h3 className="mb-4 text-2xl font-bold">Why SRH Is Special</h3>
            <p className="mb-4">SRH earned respect in IPL because of:</p>
            <ul className="space-y-2 list-disc list-inside">
              <li>Consistent playoff performances</li>
              <li>Legendary overseas players</li>
              <li>Strong bowling culture</li>
              <li>Tactical captaincy</li>
              <li>Fearless batting transformation in recent years</li>
            </ul>
            <p className="mt-4 text-lg">
              The franchise evolved from a bowling-dominant side into one of the
              most explosive batting teams in T20 cricket history.
            </p>
          </section>
        </div>
      )}

      {/* Royal Challengers Bengaluru History Section */}
      {teamname === "royal-challengers-bangalore" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-red-900 to-red-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Royal Challengers Bengaluru — Complete IPL History
          </h2>

          <section className="mb-8">
            <h3 className="mb-4 text-xl font-semibold">Team Overview</h3>
            <ul className="mb-4 space-y-2 list-disc list-inside">
              <li>
                <strong>Founded:</strong> 2008
              </li>
              <li>
                <strong>League:</strong> Indian Premier League (IPL)
              </li>
              <li>
                <strong>Home Ground:</strong> M. Chinnaswamy Stadium
              </li>
              <li>
                <strong>Owners:</strong> United Spirits Limited
              </li>
              <li>
                <strong>Team Colors:</strong> Red, Black, Gold
              </li>
              <li>
                <strong>Nickname:</strong> RCB
              </li>
            </ul>
            <p className="text-lg">
              RCB became one of the most popular IPL franchises mainly because
              of legendary players like Virat Kohli, AB de Villiers, and Chris
              Gayle. Even without early trophies, the team built a massive
              global fanbase.
            </p>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">IPL Trophy History 🏆</h3>
            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                🏆 IPL Champions — 2025
              </h4>
              <p className="mb-4">
                RCB finally won their <strong>first IPL title in 2025</strong>,
                ending a long wait of 18 seasons. The victory became one of the
                biggest emotional moments in IPL history for fans.
              </p>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">
                  Key Highlights of 2025 Season
                </h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>
                    Strong balanced squad with explosive batting and improved
                    bowling.
                  </li>
                  <li>
                    Excellent performances throughout league stages and
                    playoffs.
                  </li>
                  <li>
                    Leadership and experience from senior players helped the
                    team dominate pressure matches.
                  </li>
                  <li>
                    Massive celebrations across Bengaluru after the title win.
                  </li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">
                  Important Players in 2025
                </h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Virat Kohli</li>
                  <li>Rajat Patidar</li>
                  <li>Faf du Plessis</li>
                  <li>Mohammed Siraj</li>
                  <li>Glenn Maxwell</li>
                </ul>
              </div>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              RCB Journey Through IPL Seasons
            </h3>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                Early Years (2008–2010)
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>RCB struggled badly in the inaugural 2008 season.</li>
                <li>
                  In 2009, the team transformed under captain Anil Kumble and
                  reached the final.
                </li>
                <li>Lost the 2009 final to Deccan Chargers.</li>
              </ul>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2011 — Runner-Up Season
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Arrival of Chris Gayle changed the franchise forever.</li>
                <li>Gayle dominated bowlers with explosive batting.</li>
                <li>
                  RCB reached the final again but lost to Chennai Super Kings.
                </li>
              </ul>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2013–2016 Golden Batting Era
              </h4>
              <p className="mb-4">
                This era featured one of the strongest batting lineups in IPL
                history:
              </p>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Virat Kohli</li>
                <li>AB de Villiers</li>
                <li>Chris Gayle</li>
              </ul>
              <div>
                <h5 className="mb-2 text-lg font-semibold">
                  2016 Historic Season
                </h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>
                    Virat Kohli scored a record <strong>973 runs</strong>, still
                    one of the greatest IPL seasons ever.
                  </li>
                  <li>RCB reached the final.</li>
                  <li>Lost to Sunrisers Hyderabad in a thrilling final.</li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2017–2021 Difficult Years
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Team faced inconsistency despite having star players.</li>
                <li>Frequent bowling issues affected playoff chances.</li>
                <li>
                  However, fan support remained among the strongest in IPL.
                </li>
              </ul>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                2022–2024 Rebuild Phase
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Young Indian talents started emerging.</li>
                <li>Better bowling attack improved overall balance.</li>
                <li>
                  Regular playoff appearances showed progress toward becoming
                  champions.
                </li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Legendary RCB Players</h3>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">Virat Kohli</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Highest run-scorer in RCB history.</li>
                <li>Face of the franchise for more than a decade.</li>
                <li>
                  Emotional connection with fans made him the symbol of RCB.
                </li>
              </ul>
            </div>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">AB de Villiers</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Known as “Mr. 360”.</li>
                <li>Played some of the most unbelievable IPL innings.</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Chris Gayle</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>One of the most destructive T20 batters ever.</li>
                <li>Scored 175* — highest individual IPL score.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Famous RCB Records</h3>
            <ul className="space-y-2 list-disc list-inside">
              <li>
                Highest Team Total: <strong>263/5</strong>
              </li>
              <li>
                Highest Individual Score: <strong>175*</strong> by Chris Gayle
              </li>
              <li>Most Runs for RCB: Virat Kohli</li>
              <li>Most Emotional Fanbase in IPL history.</li>
            </ul>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Why RCB Became So Popular
            </h3>
            <ul className="space-y-2 list-disc list-inside">
              <li>Massive support from Bengaluru and across India.</li>
              <li>Presence of superstar players.</li>
              <li>Aggressive and entertaining style of cricket.</li>
              <li>Strong social media and fan culture.</li>
              <li>
                “Ee Sala Cup Namde” became one of IPL’s most famous fan slogans.
              </li>
            </ul>
          </section>

          <hr className="mb-8 border-red-500" />

          <section>
            <h3 className="mb-4 text-2xl font-bold">RCB IPL Trophy Timeline</h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-red-800/50">
                <thead>
                  <tr className="border-b border-red-500">
                    <th className="p-3 text-left">Year</th>
                    <th className="p-3 text-left">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">2009</td>
                    <td className="p-3">Runner-Up</td>
                  </tr>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">2011</td>
                    <td className="p-3">Runner-Up</td>
                  </tr>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">2016</td>
                    <td className="p-3">Runner-Up</td>
                  </tr>
                  <tr>
                    <td className="p-3">2025</td>
                    <td className="p-3">🏆 Champions</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-4 text-lg">
              RCB’s 2025 trophy victory completed one of the longest and most
              emotional journeys in IPL history.
            </p>
          </section>
        </div>
      )}

      {/* Gujarat Titans History Section */}
      {teamname === "gujarat-titans" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-blue-900 to-blue-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Gujarat Titans — Complete IPL History
          </h2>

          <section className="mb-8">
            <h3 className="mb-4 text-xl font-semibold">Team Overview</h3>
            <ul className="mb-4 space-y-2 list-disc list-inside">
              <li>
                <strong>Founded:</strong> 2021
              </li>
              <li>
                <strong>League:</strong> Indian Premier League
              </li>
              <li>
                <strong>Home Ground:</strong> Narendra Modi Stadium
              </li>
              <li>
                <strong>Owner:</strong> CVC Capital Partners
              </li>
              <li>
                <strong>Team Colors:</strong> Dark Blue
              </li>
              <li>
                <strong>Captain in Debut Season:</strong> Hardik Pandya
              </li>
            </ul>
            <p className="text-lg">
              Gujarat Titans entered the IPL as a new franchise in 2022 along
              with Lucknow Super Giants. Despite being a brand-new team, Gujarat
              Titans shocked everyone by winning the IPL title in their very
              first season.
            </p>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">🏆 IPL Champions — 2022</h3>
            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">Dream Debut Season</h4>
              <p className="mb-4">
                The 2022 IPL season became historic because Gujarat Titans won
                the championship in their inaugural year.
              </p>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Final Match</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>
                    Gujarat Titans defeated Rajasthan Royals in the IPL 2022
                    Final.
                  </li>
                  <li>Venue: Narendra Modi Stadium</li>
                  <li>
                    Captain Hardik Pandya delivered an all-round masterclass.
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-4 text-xl font-semibold">
                Key Players of 2022
              </h4>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Hardik Pandya</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Captain and match-winner.</li>
                  <li>Led calmly and contributed with both bat and ball.</li>
                </ul>
              </div>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Shubman Gill</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Played crucial innings throughout the season.</li>
                  <li>Hit the winning shot in the final.</li>
                </ul>
              </div>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Rashid Khan</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Match-winning spinner and finisher.</li>
                  <li>One of the most dangerous T20 all-rounders.</li>
                </ul>
              </div>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Mohammed Shami</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Powerful pace bowling in powerplays.</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">David Miller</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Famous for finishing games under pressure.</li>
                </ul>
              </div>
            </div>

            <div>
              <h4 className="mb-4 text-xl font-semibold">
                2022 Season Highlights
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Finished at the top of the league table.</li>
                <li>Strong bowling attack helped defend difficult totals.</li>
                <li>Team became famous for winning close matches.</li>
                <li>Excellent captaincy by Hardik Pandya.</li>
                <li>
                  Debut title win made GT one of the strongest new IPL
                  franchises ever.
                </li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">2023 Season — Runner-Up</h3>
            <ul className="space-y-1 list-disc list-inside">
              <li>Gujarat Titans again reached the IPL Final in 2023.</li>
              <li>
                Shubman Gill had a sensational season and won the Orange Cap.
              </li>
              <li>Lost a thrilling final to Chennai Super Kings.</li>
            </ul>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Team Identity & Playing Style
            </h3>
            <p className="mb-4">Gujarat Titans quickly became known for:</p>
            <ul className="mb-4 space-y-1 list-disc list-inside">
              <li>Calm leadership</li>
              <li>Strong fast bowling</li>
              <li>Match-finishing ability</li>
              <li>Smart tactical decisions</li>
              <li>Dependable all-rounders</li>
            </ul>
            <p>
              Unlike many IPL teams that depended mainly on star batters, GT
              succeeded because of balanced teamwork and strong bowling depth.
            </p>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Important Gujarat Titans Records
            </h3>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">Major Achievements</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  🏆 IPL Champions: <strong>2022</strong>
                </li>
                <li>
                  IPL Runner-Up: <strong>2023</strong>
                </li>
                <li>
                  Won IPL title in debut season — one of the rarest achievements
                  in cricket history.
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Memorable Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Hardik Pandya</li>
                <li>Shubman Gill</li>
                <li>Rashid Khan</li>
                <li>Mohammed Shami</li>
                <li>David Miller</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-blue-500" />

          <section>
            <h3 className="mb-4 text-2xl font-bold">
              Gujarat Titans IPL Timeline
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-blue-800/50">
                <thead>
                  <tr className="border-b border-blue-500">
                    <th className="p-3 text-left">Year</th>
                    <th className="p-3 text-left">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-blue-500/50">
                    <td className="p-3">2022</td>
                    <td className="p-3">🏆 Champions</td>
                  </tr>
                  <tr>
                    <td className="p-3">2023</td>
                    <td className="p-3">Runner-Up</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-4 text-lg">
              Gujarat Titans had one of the greatest starts ever by a new
              franchise in the history of the Indian Premier League.
            </p>
          </section>
        </div>
      )}

      {/* Rajasthan Royals History Section */}
      {teamname === "rajasthan-royals" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-pink-900 to-pink-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Rajasthan Royals — Complete IPL History
          </h2>

          <section className="mb-8">
            <h3 className="mb-4 text-xl font-semibold">Team Overview</h3>
            <ul className="mb-4 space-y-2 list-disc list-inside">
              <li>
                <strong>Founded:</strong> 2008
              </li>
              <li>
                <strong>League:</strong> Indian Premier League
              </li>
              <li>
                <strong>Home Ground:</strong> Sawai Mansingh Stadium
              </li>
              <li>
                <strong>Owners:</strong> Royal Multisport Private Limited
              </li>
              <li>
                <strong>Team Colors:</strong> Pink, Blue
              </li>
              <li>
                <strong>Nickname:</strong> RR
              </li>
            </ul>
            <p className="text-lg">
              Rajasthan Royals became famous as the “underdog champions” of IPL.
              In the inaugural season, almost nobody expected them to win, but
              they shocked the cricket world by lifting the very first IPL
              trophy.
            </p>
          </section>

          <hr className="mb-8 border-pink-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">🏆 IPL Champions — 2008</h3>
            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                Historic First IPL Winners
              </h4>
              <p className="mb-4">
                The 2008 season was the beginning of IPL history, and Rajasthan
                Royals created one of the greatest underdog stories in T20
                cricket.
              </p>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Captain & Coach</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Led by legendary Australian spinner Shane Warne.</li>
                  <li>
                    Warne’s leadership, tactics, and confidence transformed a
                    relatively unknown squad into champions.
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-4 text-xl font-semibold">IPL 2008 Final</h4>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Match</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>
                    Rajasthan Royals defeated Chennai Super Kings in the final.
                  </li>
                  <li>Venue: DY Patil Stadium</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Famous Moment</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>
                    Shane Warne hit the winning run and celebrated emotionally
                    with teammates.
                  </li>
                  <li>
                    The victory became one of IPL’s most memorable moments.
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-4 text-xl font-semibold">
                Key Players of 2008
              </h4>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Shane Warne</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Inspirational captain and mentor.</li>
                  <li>Built a fearless and united team culture.</li>
                </ul>
              </div>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Shane Watson</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Outstanding all-round performances.</li>
                  <li>Important contributor with both bat and ball.</li>
                </ul>
              </div>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Yusuf Pathan</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Match-winning power hitter.</li>
                  <li>Played brilliantly in the final.</li>
                </ul>
              </div>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">Graeme Smith</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Consistent top-order batting.</li>
                </ul>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Sohail Tanvir</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Purple Cap winner in IPL 2008.</li>
                  <li>Deadly left-arm pace bowling.</li>
                </ul>
              </div>
            </div>

            <div>
              <h4 className="mb-4 text-xl font-semibold">
                Why Rajasthan Royals Won in 2008
              </h4>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">
                  Smart Team Strategy
                </h5>
                <p className="mb-2">
                  Unlike teams full of superstars, Rajasthan Royals focused on:
                </p>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Young talent</li>
                  <li>Team chemistry</li>
                  <li>Clever tactics</li>
                  <li>Aggressive cricket</li>
                </ul>
              </div>
              <div className="mb-4">
                <h5 className="mb-2 text-lg font-semibold">
                  Excellent Leadership
                </h5>
                <p>
                  Shane Warne motivated lesser-known players and turned them
                  into match winners.
                </p>
              </div>
              <div>
                <h5 className="mb-2 text-lg font-semibold">
                  Discovering Young Talent
                </h5>
                <p>
                  RR helped popularize several young Indian players who later
                  became stars.
                </p>
              </div>
            </div>
          </section>

          <hr className="mb-8 border-pink-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Post-2008 Journey</h3>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">2009–2013</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Team remained competitive but could not win another title.
                </li>
                <li>Continued developing young players.</li>
              </ul>
            </div>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">
                2013 Spot-Fixing Controversy
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Franchise faced suspension-related controversies.</li>
                <li>IPL reputation was affected during this period.</li>
              </ul>
            </div>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">
                2016–2017 Suspension
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Rajasthan Royals were suspended from IPL for two seasons.
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">2018 Return</h4>
              <p className="mb-2">Returned strongly with players like:</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>Jos Buttler</li>
                <li>Sanju Samson</li>
                <li>Ben Stokes</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-pink-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Modern Rajasthan Royals Era
            </h3>
            <div>
              <h4 className="mb-2 text-xl font-semibold">
                2022 Runner-Up Season
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Rajasthan Royals reached the IPL final after many years.
                </li>
                <li>
                  Jos Buttler had an incredible season with multiple centuries.
                </li>
                <li>Lost the final to Gujarat Titans.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-pink-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Famous Rajasthan Royals Records
            </h3>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">Major Achievements</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  🏆 IPL Champions: <strong>2008</strong>
                </li>
                <li>
                  IPL Runner-Up: <strong>2022</strong>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Important Records</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>First-ever IPL champions.</li>
                <li>Famous for scouting and developing young talent.</li>
                <li>One of IPL’s most unpredictable and exciting teams.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-pink-500" />

          <section>
            <h3 className="mb-4 text-2xl font-bold">
              Rajasthan Royals IPL Timeline
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-pink-800/50">
                <thead>
                  <tr className="border-b border-pink-500">
                    <th className="p-3 text-left">Year</th>
                    <th className="p-3 text-left">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-pink-500/50">
                    <td className="p-3">2008</td>
                    <td className="p-3">🏆 Champions</td>
                  </tr>
                  <tr>
                    <td className="p-3">2022</td>
                    <td className="p-3">Runner-Up</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-4 text-lg">
              Rajasthan Royals will always be remembered as the team that won
              the very first IPL trophy and proved that teamwork and smart
              leadership can defeat star-studded squads.
            </p>
          </section>
        </div>
      )}

      {/* Lucknow Super Giants History Section */}
      {teamname === "lucknow-super-giants" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-cyan-900 to-cyan-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Lucknow Super Giants — IPL History
          </h2>

          <section className="mb-8">
            <h3 className="mb-4 text-xl font-semibold">Team Overview</h3>
            <ul className="mb-4 space-y-2 list-disc list-inside">
              <li>
                <strong>Founded:</strong> 2021
              </li>
              <li>
                <strong>League:</strong> Indian Premier League
              </li>
              <li>
                <strong>Home Ground:</strong> Bharat Ratna Shri Atal Bihari
                Vajpayee Ekana Cricket Stadium
              </li>
              <li>
                <strong>Owner:</strong> RPSG Group
              </li>
              <li>
                <strong>Team Colors:</strong> Light Blue
              </li>
              <li>
                <strong>Captain (initial years):</strong> KL Rahul
              </li>
            </ul>
            <p className="text-lg">
              Lucknow Super Giants joined the IPL in 2022 along with Gujarat
              Titans. While Gujarat Titans immediately won the trophy, LSG
              became known for being a consistent playoff team but still
              searching for their first IPL title.
            </p>
          </section>

          <hr className="mb-8 border-cyan-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">IPL Journey</h3>

            <div className="mb-8">
              <h4 className="mb-4 text-xl font-semibold">
                2022 — Strong Debut Season
              </h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Finished in the Top 4 during their very first season.</li>
                <li>
                  Played aggressive cricket with strong batting performances.
                </li>
                <li>Lost in the Eliminator to Royal Challengers Bengaluru.</li>
              </ul>
              <div>
                <h5 className="mb-2 text-lg font-semibold">Key Players</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>KL Rahul</li>
                  <li>Quinton de Kock</li>
                  <li>Deepak Hooda</li>
                  <li>Avesh Khan</li>
                </ul>
              </div>
            </div>

            <div>
              <h4 className="mb-4 text-xl font-semibold">
                2023 — Another Playoff Appearance
              </h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Again qualified for playoffs.</li>
                <li>Team showed consistency across league matches.</li>
                <li>Lost Eliminator to Mumbai Indians.</li>
              </ul>
              <div>
                <h5 className="mb-2 text-lg font-semibold">
                  Important Players
                </h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Marcus Stoinis</li>
                  <li>Nicholas Pooran</li>
                  <li>Ravi Bishnoi</li>
                </ul>
              </div>
            </div>
          </section>

          <hr className="mb-8 border-cyan-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Team Identity</h3>
            <div className="mb-6">
              <h4 className="mb-2 text-xl font-semibold">Strengths</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Explosive middle order</li>
                <li>Strong overseas players</li>
                <li>Balanced squad depth</li>
                <li>Consistent league-stage performances</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Challenges</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Knockout match pressure</li>
                <li>Bowling inconsistency in key matches</li>
                <li>Still chasing first IPL trophy</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-cyan-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Fan Culture & Memes 😄</h3>
            <p className="mb-4">
              LSG quickly became part of IPL meme culture because:
            </p>
            <ul className="mb-4 space-y-1 list-disc list-inside">
              <li>Close playoff exits.</li>
              <li>Funny social media reactions.</li>
              <li>Emotional fan moments.</li>
              <li>
                Comparisons with newer successful teams like Gujarat Titans.
              </li>
            </ul>
            <p>
              But despite the jokes, LSG has actually been one of the more
              consistent new franchises in IPL.
            </p>
          </section>

          <hr className="mb-8 border-cyan-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Major Records & Achievements
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-cyan-800/50">
                <thead>
                  <tr className="border-b border-cyan-500">
                    <th className="p-3 text-left">Achievement</th>
                    <th className="p-3 text-left">Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-cyan-500/50">
                    <td className="p-3">IPL Debut</td>
                    <td className="p-3">2022</td>
                  </tr>
                  <tr className="border-b border-cyan-500/50">
                    <td className="p-3">Best Finish</td>
                    <td className="p-3">Playoffs</td>
                  </tr>
                  <tr className="border-b border-cyan-500/50">
                    <td className="p-3">Consecutive Playoffs</td>
                    <td className="p-3">2022, 2023</td>
                  </tr>
                  <tr>
                    <td className="p-3">First Trophy</td>
                    <td className="p-3">Still Pending</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <hr className="mb-8 border-cyan-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Star Players in LSG History
            </h3>
            <ul className="space-y-1 list-disc list-inside">
              <li>KL Rahul</li>
              <li>Nicholas Pooran</li>
              <li>Marcus Stoinis</li>
              <li>Quinton de Kock</li>
              <li>Ravi Bishnoi</li>
            </ul>
          </section>

          <hr className="mb-8 border-cyan-500" />

          <section>
            <h3 className="mb-4 text-2xl font-bold">
              Lucknow Super Giants IPL Timeline
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-cyan-800/50">
                <thead>
                  <tr className="border-b border-cyan-500">
                    <th className="p-3 text-left">Year</th>
                    <th className="p-3 text-left">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-cyan-500/50">
                    <td className="p-3">2022</td>
                    <td className="p-3">Playoffs</td>
                  </tr>
                  <tr>
                    <td className="p-3">2023</td>
                    <td className="p-3">Playoffs</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-4 text-lg">
              Lucknow Super Giants may still be waiting for their first IPL
              trophy, but they have already built a competitive team and a
              strong fanbase in a very short time.
            </p>
          </section>
        </div>
      )}

      {/* Delhi Capitals History Section */}
      {teamname === "delhi-capitals" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-red-900 to-red-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Delhi Capitals — Complete IPL History
          </h2>

          <section className="mb-8">
            <h3 className="mb-4 text-xl font-semibold">Team Overview</h3>
            <ul className="mb-4 space-y-2 list-disc list-inside">
              <li>
                <strong>Founded:</strong> 2008
              </li>
              <li>
                <strong>Original Name:</strong> Delhi Daredevils
              </li>
              <li>
                <strong>Renamed:</strong> Delhi Capitals (2019)
              </li>
              <li>
                <strong>League:</strong> Indian Premier League
              </li>
              <li>
                <strong>Home Ground:</strong> Arun Jaitley Stadium
              </li>
              <li>
                <strong>Owners:</strong> GMR Group and JSW Group
              </li>
              <li>
                <strong>Team Colors:</strong> Blue and Red
              </li>
            </ul>
            <p className="text-lg">
              Delhi Capitals is one of the oldest IPL franchises and has
              produced many exciting players and memorable seasons. Despite
              several strong squads over the years, the team is still searching
              for its first IPL trophy.
            </p>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Early Era — Delhi Daredevils (2008–2012)
            </h3>
            <p className="mb-4">
              During the early IPL years, Delhi had one of the most dangerous
              batting lineups.
            </p>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Star Players</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Virender Sehwag</li>
                <li>Gautam Gambhir</li>
                <li>AB de Villiers</li>
                <li>David Warner</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Highlights</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Reached semifinals multiple times.</li>
                <li>Known for aggressive batting.</li>
                <li>
                  Often played entertaining cricket but struggled in knockout
                  matches.
                </li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Difficult Years (2013–2018)
            </h3>
            <p className="mb-4">
              This period became difficult for the franchise:
            </p>
            <ul className="space-y-1 list-disc list-inside">
              <li>Frequent captain changes.</li>
              <li>Inconsistent performances.</li>
              <li>Finished near the bottom of the table several times.</li>
              <li>
                Became a regular part of IPL meme culture because of
                underperforming squads despite big expectations.
              </li>
            </ul>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Rebranding to Delhi Capitals (2019)
            </h3>
            <p className="mb-4">
              The franchise changed its name from{" "}
              <strong>Delhi Daredevils</strong> to{" "}
              <strong>Delhi Capitals</strong> in 2019.
            </p>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Goal of Rebranding</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Build a fresh identity.</li>
                <li>Focus on young Indian talent.</li>
                <li>Create a long-term competitive team.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Rise of Young Stars</h3>
            <p className="mb-4">Delhi started building around young stars:</p>
            <ul className="mb-4 space-y-1 list-disc list-inside">
              <li>Rishabh Pant</li>
              <li>Shreyas Iyer</li>
              <li>Prithvi Shaw</li>
              <li>Kagiso Rabada</li>
            </ul>
            <p>
              This new core transformed the franchise into a serious playoff
              contender.
            </p>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">2020 — First IPL Final</h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">
                Historic Achievement
              </h4>
              <p>Delhi Capitals reached their first-ever IPL final in 2020.</p>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Key Moments</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Strong performances throughout the season.</li>
                <li>Excellent captaincy by Shreyas Iyer.</li>
                <li>Powerful bowling attack led by Kagiso Rabada.</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Final Result</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Lost the final to Mumbai Indians.</li>
              </ul>
              <p className="mt-2">
                Even though they lost, 2020 became the greatest season in Delhi
                Capitals history.
              </p>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              Modern Delhi Capitals Era
            </h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Strengths</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Young Indian core players.</li>
                <li>Explosive batting lineup.</li>
                <li>Aggressive cricket style.</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">Challenges</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Inconsistency in pressure matches.</li>
                <li>Frequent injuries and squad changes.</li>
                <li>Still chasing their first IPL trophy.</li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">Legendary Delhi Players</h3>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Virender Sehwag</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>One of the most explosive batters in IPL history.</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Rishabh Pant</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Became the face of modern Delhi Capitals.</li>
              </ul>
            </div>
            <div className="mb-4">
              <h4 className="mb-2 text-xl font-semibold">Shreyas Iyer</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>Led the team to their first IPL final.</li>
              </ul>
            </div>
            <div>
              <h4 className="mb-2 text-xl font-semibold">David Warner</h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Important senior batter for the franchise across different
                  eras.
                </li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section>
            <h3 className="mb-4 text-2xl font-bold">
              Delhi Capitals IPL Timeline
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-red-800/50">
                <thead>
                  <tr className="border-b border-red-500">
                    <th className="p-3 text-left">Year</th>
                    <th className="p-3 text-left">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">2008–2012</td>
                    <td className="p-3">Strong playoff team</td>
                  </tr>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">2013–2018</td>
                    <td className="p-3">Struggling years</td>
                  </tr>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">2019</td>
                    <td className="p-3">Rebranded as Delhi Capitals</td>
                  </tr>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">2020</td>
                    <td className="p-3">Runner-Up</td>
                  </tr>
                  <tr>
                    <td className="p-3">Trophy Wins</td>
                    <td className="p-3">🏆 0</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-4 text-lg">
              Delhi Capitals remains one of the most entertaining franchises in
              the Indian Premier League, with loyal fans still waiting for the
              team’s first IPL championship.
            </p>
          </section>
        </div>
      )}

      {/* Punjab Kings History Section */}
      {teamname === "punjab-kings" && (
        <div className="p-6 mb-8 text-white bg-gradient-to-br from-red-900 to-red-700 rounded-xl shadow-xl">
          <h2 className="mb-6 text-3xl font-bold text-center">
            Punjab Kings — Complete IPL History
          </h2>

          <section className="mb-8">
            <h3 className="mb-4 text-xl font-semibold">📅 Team Overview</h3>
            <ul className="mb-4 space-y-2 list-disc list-inside">
              <li>
                Founded: <strong>2008</strong>
              </li>
              <li>
                Original Name: <strong>Kings XI Punjab (KXIP)</strong>
              </li>
              <li>
                Renamed to <strong>Punjab Kings (PBKS)</strong> in{" "}
                <strong>2021</strong>
              </li>
              <li>Home Grounds:</li>
              <ul className="ml-6 space-y-1 list-disc list-inside">
                <li>Maharaja Yadavindra Singh International Cricket Stadium</li>
                <li>IS Bindra Stadium</li>
              </ul>
              <li>Owners:</li>
              <ul className="ml-6 space-y-1 list-disc list-inside">
                <li>Preity Zinta</li>
                <li>Ness Wadia</li>
                <li>Mohit Burman</li>
                <li>Karan Paul</li>
              </ul>
            </ul>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              🏆 Punjab Kings IPL Journey (2008–2025)
            </h3>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                🔥 2008 – Dream Start
              </h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>
                  Reached the <strong>Semi-Finals</strong>
                </li>
                <li>Captain: Yuvraj Singh</li>
                <li>Star Performers:</li>
              </ul>
              <ul className="ml-6 space-y-1 list-disc list-inside">
                <li>Shaun Marsh — Orange Cap Winner</li>
                <li>Kumar Sangakkara</li>
                <li>Brett Lee</li>
              </ul>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                📉 2009–2013 – Struggling Phase
              </h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Mostly mid-table and lower finishes</li>
                <li>Frequent captain changes</li>
                <li>Notable players:</li>
              </ul>
              <ul className="ml-6 space-y-1 list-disc list-inside">
                <li>Adam Gilchrist</li>
                <li>David Hussey</li>
                <li>Paul Valthaty</li>
              </ul>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                🥈 2014 – Historic Season
              </h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>
                  Finished as <strong>IPL Runners-up</strong>
                </li>
                <li>Captain: George Bailey</li>
                <li>Star players:</li>
              </ul>
              <ul className="mb-4 ml-6 space-y-1 list-disc list-inside">
                <li>Glenn Maxwell</li>
                <li>David Miller</li>
                <li>Virender Sehwag</li>
              </ul>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Lost Final to Kolkata Knight Riders</li>
              </ul>
              <div>
                <h5 className="mb-2 text-lg font-semibold">🌟 Highlights</h5>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Maxwell dominated IPL with explosive batting</li>
                  <li>Sehwag scored legendary 122 in Qualifier 2</li>
                  <li>PBKS became one of the most feared batting teams</li>
                </ul>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                😔 2015–2020 – Long Playoff Drought
              </h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Failed to qualify for playoffs</li>
                <li>Multiple captain and coaching changes</li>
                <li>Key players:</li>
              </ul>
              <ul className="ml-6 space-y-1 list-disc list-inside">
                <li>KL Rahul</li>
                <li>Chris Gayle</li>
                <li>Mayank Agarwal</li>
                <li>Mohammed Shami</li>
              </ul>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                👑 2021 – Punjab Kings Era Begins
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Official rebrand from <strong>Kings XI Punjab</strong> →{" "}
                  <strong>Punjab Kings</strong>
                </li>
                <li>New logo and fresh identity launched</li>
                <li>Focus shifted to building a younger aggressive squad</li>
              </ul>
            </div>

            <div className="mb-8">
              <h4 className="mb-2 text-xl font-semibold">
                ⚔️ 2022–2024 – Rebuilding Years
              </h4>
              <ul className="mb-4 space-y-1 list-disc list-inside">
                <li>Competitive but inconsistent performances</li>
                <li>Important players:</li>
              </ul>
              <ul className="mb-4 ml-6 space-y-1 list-disc list-inside">
                <li>Shikhar Dhawan</li>
                <li>Sam Curran</li>
                <li>Arshdeep Singh</li>
                <li>Liam Livingstone</li>
              </ul>
              <ul className="space-y-1 list-disc list-inside">
                <li>Continued search for maiden IPL trophy</li>
              </ul>
            </div>

            <div>
              <h4 className="mb-2 text-xl font-semibold">
                🥈 2025 – Second IPL Final Appearance
              </h4>
              <ul className="space-y-1 list-disc list-inside">
                <li>
                  Reached the <strong>IPL 2025 Final</strong>
                </li>
                <li>
                  Finished as <strong>Runners-up</strong>
                </li>
                <li>Marked PBKS’s best campaign since 2014</li>
                <li>
                  Young core and aggressive cricket impressed fans throughout
                  the season
                </li>
                <li>
                  Strong performances from Indian and overseas stars helped PBKS
                  return to the top stage
                </li>
              </ul>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section className="mb-8">
            <h3 className="mb-4 text-2xl font-bold">
              📊 Punjab Kings IPL Record (Till 2025)
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full rounded-lg bg-red-800/50">
                <thead>
                  <tr className="border-b border-red-500">
                    <th className="p-3 text-left">Achievement</th>
                    <th className="p-3 text-left">Record</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">🏆 IPL Titles</td>
                    <td className="p-3">0</td>
                  </tr>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">🥈 Runners-up</td>
                    <td className="p-3">2 (2014, 2025)</td>
                  </tr>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">✅ Playoff Appearances</td>
                    <td className="p-3">3</td>
                  </tr>
                  <tr className="border-b border-red-500/50">
                    <td className="p-3">⭐ Best Seasons</td>
                    <td className="p-3">2014, 2025</td>
                  </tr>
                  <tr>
                    <td className="p-3">🔥 Most Loyal Face</td>
                    <td className="p-3">Preity Zinta</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <hr className="mb-8 border-red-500" />

          <section>
            <h3 className="mb-4 text-2xl font-bold">😂 PBKS Meme Culture</h3>
            <p className="mb-4">Punjab Kings became famous online for:</p>
            <ul className="mb-4 space-y-1 list-disc list-inside">
              <li>“This year is our year” memes</li>
              <li>Unpredictable performances</li>
              <li>Strong squads but inconsistent results</li>
              <li>Entertaining high-scoring matches</li>
            </ul>
            <p className="text-lg">
              Despite no IPL trophy yet, PBKS has one of the most passionate
              fanbases in IPL history.
            </p>
          </section>
        </div>
      )}

      <div className="flex flex-col gap-6">
        <h2 className="mb-4 text-2xl font-bold">Players</h2>

        {batters.length > 0 && (
          <div>
            <h3 className="mb-2 text-xl font-bold">Batters</h3>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
              {batters.map((player, index) => (
                <Link
                  key={index}
                  to={`/teams/${teamname}/${player.playercode}`}
                >
                  <div
                    className="justify-center text-center book"
                    style={{
                      backgroundImage: `url(${bgImage})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      color: textColor,
                    }}
                  >
                    <div className="inline-block">
                      <p className="block max-w-[150px] ml-2 text-center">
                        {player.role}
                      </p>
                    </div>
                    <div
                      className="flex flex-col cover"
                      style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        color: textColor,
                      }}
                    >
                      <img
                        src={player.image}
                        className="w-[100%] drop-shadow-2xl"
                        alt={player.name}
                      />
                      <p className="mt-4">{player.name}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}

        {allRounders.length > 0 && (
          <div>
            <h3 className="mb-2 text-xl font-bold">All-rounders</h3>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
              {allRounders.map((player, index) => (
                <div
                  key={index}
                  className="justify-center text-center book"
                  style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    color: textColor,
                  }}
                >
                  <div className="inline-block">
                    <p className="block max-w-[150px] ml-2">{player.role}</p>
                  </div>
                  <div
                    className="flex flex-col cover"
                    style={{
                      backgroundImage: `url(${bgImage})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      color: textColor,
                    }}
                  >
                    <img
                      src={player.image}
                      className="w-[100%] drop-shadow-2xl"
                      alt={player.name}
                    />
                    <p className="mt-4">{player.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {bowlers.length > 0 && (
          <div>
            <h3 className="mb-2 text-xl font-bold">Bowlers</h3>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
              {bowlers.map((player, index) => (
                <div
                  key={index}
                  className="justify-center text-center book"
                  style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    color: textColor,
                  }}
                >
                  <div className="inline-block">
                    <p className="block max-w-[150px] ml-2">{player.role}</p>
                  </div>
                  <div
                    className="flex flex-col cover"
                    style={{
                      backgroundImage: `url(${bgImage})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      color: textColor,
                    }}
                  >
                    <img
                      src={player.image}
                      className="w-[100%] drop-shadow-2xl"
                      alt={player.name}
                    />
                    <p className="mt-4">{player.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Players;
